<template>
    <div class="mini-overlay" tabindex="0" ref="root">
        <div class="mini-card">
            <div class="game-container">
                <div class="card" v-for="card in shuffledCards" :key="card.id" @click="flipCard(card)">
                    <img v-if="card.flipped" style="width: 100%;" :src="card.image" alt="Card Image" />
                    <div v-else class="card-back">?</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    emits: ['done', 'close'],
    data() {
        return {
            cards: [
                { id: 1, image: require('@/assets/items/Book.webp'), flipped: false },
                { id: 2, image: require('@/assets/items/Emeralds.webp'), flipped: false },
                { id: 3, image: require('@/assets/items/Spawner.webp'), flipped: false },
                { id: 4, image: require('@/assets/items/Very_Very_Frightening.webp'), flipped: false },
                { id: 5, image: require('@/assets/items/Hot_Stuff.webp'), flipped: false },
                { id: 6, image: require('@/assets/items/Local_Brewery.webp'), flipped: false },
                { id: 7, image: require('@/assets/items/Suit_Up.webp'), flipped: false },
                { id: 8, image: require('@/assets/items/Oh_Shiny.webp'), flipped: false },
                { id: 9, image: require('@/assets/items/Villager_Spawn_Egg.webp'), flipped: false },
                { id: 10, image: require('@/assets/items/Resource_Blocks.webp'), flipped: false },
                { id: 11, image: require('@/assets/items/Flint_and_Steel.webp'), flipped: false },
                { id: 12, image: require('@/assets/items/Enchanting.webp'), flipped: false },
                { id: 1, image: require('@/assets/items/Book.webp'), flipped: false },
                { id: 2, image: require('@/assets/items/Emeralds.webp'), flipped: false },
                { id: 3, image: require('@/assets/items/Spawner.webp'), flipped: false },
                { id: 4, image: require('@/assets/items/Very_Very_Frightening.webp'), flipped: false },
                { id: 5, image: require('@/assets/items/Hot_Stuff.webp'), flipped: false },
                { id: 6, image: require('@/assets/items/Local_Brewery.webp'), flipped: false },
                { id: 7, image: require('@/assets/items/Suit_Up.webp'), flipped: false },
                { id: 8, image: require('@/assets/items/Oh_Shiny.webp'), flipped: false },
                { id: 9, image: require('@/assets/items/Villager_Spawn_Egg.webp'), flipped: false },
                { id: 10, image: require('@/assets/items/Resource_Blocks.webp'), flipped: false },
                { id: 11, image: require('@/assets/items/Flint_and_Steel.webp'), flipped: false },
                { id: 12, image: require('@/assets/items/Enchanting.webp'), flipped: false },            
            ],
            flippedCards: [],
            matchedPairs: 0,
            shuffledCards: [],
        };
    },
    created() {
        // create initial shuffled deck
        this.shuffleCards();
    },
    methods: {
        shuffleCards() {
            // create a shallow copy and shuffle it (does not mutate original `cards` array)
            const copy = this.cards.slice();
            for (let i = copy.length - 1; i > 0; i--) {
                const j = Math.floor(Math.random() * (i + 1));
                [copy[i], copy[j]] = [copy[j], copy[i]];
            }
            // ensure flipped flags reset
            copy.forEach(c => c.flipped = false);
            this.shuffledCards = copy;
        },
        flipCard(card) {
            if (this.flippedCards.length < 2 && !card.flipped) {
                card.flipped = true;
                this.flippedCards.push(card);

                if (this.flippedCards.length === 2) {
                    this.checkForMatch();
                }
            }
        },
        checkForMatch() {
            const [firstCard, secondCard] = this.flippedCards;

            if (firstCard.id === secondCard.id) {
                this.matchedPairs++;
                if(this.matchedPairs === this.cards.length / 2) {
                    setTimeout(() => {
                        this.$emit('done');
                    }, 500);
                }
                this.flippedCards = [];
            } else {
                setTimeout(() => {
                    firstCard.flipped = false;
                    secondCard.flipped = false;
                    this.flippedCards = [];
                }, 1000);
            }
        },
        restartGame() {
            this.flippedCards = [];
            this.matchedPairs = 0;
            this.shuffleCards();
        },
    },
};
</script>

<style scoped>
.game-container {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
}

.card {
    width: 100px;
    height: 100px;
    margin: 10px;
    cursor: pointer;
    position: relative;
}

.card-back {
    width: 100%;
    height: 100%;
    background-color: #ccc;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 24px;
}
</style>